export type User = {
  _id: string;
  personId: string;
  employeeId: string;
  fullName: string;
  nickName: string;
  employeeType: string;
  email: string;
  phoneNumber: string;
  division: string;
  position: string;
  partnerType: string;
  digitalSignature: string;
  token: string;
  permissions: RolePermissions;
  profilePicture?: string;
  isSalesDataCompleted: boolean;
  accessModule: string[];
};

export type RolePermissions = {
  sales: SalesRole;
};

export type SalesRole = {
  sales: boolean;
  seniorSales: boolean;
  admin: boolean;
  elsa: boolean;
  licenseTrial: boolean;
  incentive: boolean;
  priceInformation: boolean;
  referenceNumber: boolean;
  managePartner: boolean;
  manageDistributor: boolean;
  manageProduct: boolean;
  settingsUser: boolean;
  settingsApproval: boolean;
  settingsRole: boolean;
  settingsExpiredTime: boolean;
  settingsCustomField: boolean;
  settingsTermAndCondition: boolean;
  settingsKPIAndIncentive: boolean;
  settingsPPN: boolean;
  approvalProduct: boolean;
  approvalLicenseTrial: boolean;
  approvalSPRF: boolean;
  approvalQuotation: boolean;
  approvalBillingForm: boolean;
  approvalCashback: boolean;
  approvalElsa: boolean;
  approvalQRF: boolean;
};

const getUser = (): Partial<User> =>
  (JSON.parse(localStorage.getItem('user') as string) as User) ?? {};

export default getUser;
